import { render, staticRenderFns } from "./LiveTableMulti.vue?vue&type=template&id=78813011&scoped=true&"
import script from "./LiveTableMulti.vue?vue&type=script&lang=js&"
export * from "./LiveTableMulti.vue?vue&type=script&lang=js&"
import style0 from "./LiveTableMulti.vue?vue&type=style&index=0&id=78813011&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78813011",
  null
  
)

export default component.exports